export default __webpack_public_path__ + "static/media/Ballroll_00255.a172bf03.png";